import { createSelector } from 'reselect';
import shuffle from 'lodash/shuffle';
import config from '../configs';

const { maxMerchants } = config;

export const selectTopStores = state => state.topStores;
export const selectTopStoresIsLoading = createSelector(selectTopStores, topStores => topStores.isLoading);
export const selectTopStoresIsLoaded = createSelector(selectTopStores, topStores => topStores.isLoaded);
export const selectTopStoresRecords = createSelector(selectTopStores, topStores => (
  maxMerchants ? shuffle(topStores.merchants).splice(0, maxMerchants) : topStores.merchants
));

export const selectTopStoresConfig = createSelector(
  [
    selectTopStores,
    (state, isPersonalizedMhp) => isPersonalizedMhp,
  ],
  (topStores, isPersonalizedMhp) => {
    if (isPersonalizedMhp) {
      return topStores.config.topStoresPersonalizedConfig;
    }

    return topStores.config.defaultConfig;
  },
);

export const makeSelectTopStoresConfig = () => (
  createSelector(
    selectTopStoresConfig,
    (config) => config,
  )
);
